import PieChartComponent from '../utils/PieChartComponent';
import { getTotalsGraph } from '../DiscipleshipCharts';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const GrowthTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return (
    <div className="growth-tooltip">
      <strong>{row.fullName}</strong>
      <div>Discípulos: {row.cant}</div>
      <div>Nuevos en el mes: {row.nuevos}</div>
    </div>
  );
};

export const DiscipleshipDisciplesCharts = ({
  disciplesByGenderPieChartData,
  disciplesGrowthDataForLineChart,
}) => {
  const firstPoint = disciplesGrowthDataForLineChart[0];
  const lastPoint = disciplesGrowthDataForLineChart[disciplesGrowthDataForLineChart.length - 1];

  return (
    <>
      <div className="totalLabels">
        Total de discípulos: {getTotalsGraph(disciplesByGenderPieChartData)}
      </div>
      <div className="chartSection chartSection--disciples">
        <PieChartComponent
          title="Por género"
          data={disciplesByGenderPieChartData}
          pieType="disciple"
        />
        <div className="graphic graphic--wide">
          <h3>
            Crecimiento mensual
            {firstPoint && lastPoint ? ` (${firstPoint.fullName} - ${lastPoint.fullName})` : ''}
          </h3>
          <p>Últimos 4 años · un punto por mes</p>
          {disciplesGrowthDataForLineChart?.length > 0 ? (
            <div className="growth-chart">
              <ResponsiveContainer width="100%" height={380}>
                <LineChart
                  data={disciplesGrowthDataForLineChart}
                  margin={{ top: 8, right: 16, left: 4, bottom: 8 }}
                >
                  <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                  <XAxis
                    dataKey="name"
                    interval={2}
                    angle={-45}
                    textAnchor="end"
                    height={64}
                    tick={{ fontSize: 11 }}
                    minTickGap={4}
                  />
                  <YAxis tick={{ fontSize: 12 }} width={48} />
                  <Tooltip content={<GrowthTooltip />} />
                  <Legend wrapperStyle={{ fontSize: 12 }} />
                  <Line
                    type="monotone"
                    dataKey="cant"
                    name="Discípulos"
                    stroke="#fc9133"
                    strokeWidth={2}
                    dot={{ r: 3, strokeWidth: 1, fill: '#fc9133' }}
                    activeDot={{ r: 6 }}
                    isAnimationActive={false}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div className="chart-empty">No hay datos para mostrar</div>
          )}
        </div>
      </div>
    </>
  );
};
